module.exports = __webpack_public_path__ + "img/px.b7a1ef74.png";